module.exports = __webpack_public_path__ + "static/media/Empoli.1b15c08f.png";